<script>
	import {usuario} from '../store.js'
	import {execLogin, execCheckEmail, execCheckClave, execNewUser} from '../csql.js'
	export let handler = () => console.log("Unhandled action")

	let toastAlertMessage= ''
	let toastDialogMessage= ''
	let loading = false
	let params = { email:'', clave:''}
	let emailOk = false
	let registroOn = false

	let isRegistered = false
	let randomClave = 'mayo2021'

	function isValidEmail(em){
		var mailformat =  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
		return em.match(mailformat)
	}

	function submit(){
		toastAlertMessage = ""
		// toastDialogMessage = ""

		if(!emailOk) verifyEmail()
		else{
			params.email = params.email.trim().toLowerCase()
			params.clave = params.clave.trim().toLowerCase()
			if(params.clave.trim() === randomClave){
				if(!isRegistered) registrar()
				 else verifyPass()
			}else{
				toastDialogMessage = "Clave incorrecta"
			}
		}
	}

	function cancelToastDialog(){
		toastDialogMessage=''	
	}

	function registrar(){
		handler({response:0,view_dst:"registro",email:params.email})
	}

	async function verifyEmail(){
		loading= true
		toastAlertMessage = ""
		if(!isValidEmail(params.email)){
			toastAlertMessage = "El email no es valido, verifiquelo por favor!"
			return
		}
		toastAlertMessage = "Verificando usuario"
		const data = await execCheckEmail({params})
		loading = false
		toastAlertMessage = ""
		emailOk = true
		if(data.ok){
			//email valido, solicitar la clave
			isRegistered = true
		}else{
			// email no registrado, registrar?
			isRegistered = false
			//toastDialogMessage = 'Aun no estas registrado/a como mayorista, Hazlo ahora.'
				//regUser()
		}
		
	}

	async function verifyPass(){
		toastAlertMessage = ""
		loading= true
		// toastAlertMessage = "Verificando su clave"
		const data = await execCheckClave({params})
		loading= false
		toastAlertMessage = ""
		if(data.ok){
			let usr = data.data[0]
			usuario.set(usr)
			delete usr.clave
			localStorage.setItem('UPM_USER',JSON.stringify({user:usr}))
			salirOk()
		}else{
			toastDialogMessage = "Clave incorrecta"
		}
	}	

	function salirOk(){
		handler({response:0,view_dst:"catalogo"})
	}

	function salir(){
		handler({response:-1,view_dst:"catalogo"})
	}

</script>

<div class="modal">
	<div class="card responsive-margin">
		<div class="section responsive-padding bg-gray-200">
			<label for="" on:click={()=>emailOk = !emailOk}>
				<small>Email
					{#if emailOk} <span> &#9989;</span> {/if}	
				</small>
			</label>
			<input type="text" style="width: 94%;" placeholder="Ingrese email" bind:value={params.email} readonly={emailOk}>

			{#if emailOk}
				<label for=""><small>Clave</small></label><br>
				<input type="text" style="width: 94%;" placeholder="Clave" bind:value={params.clave}>
				<div class="text-center" style="font-weight:normal;">Solicita la clave a nuestro nro WhatsApp : 5491130503438</div>
			{/if}

		</div>		
		<div class="section" style="text-align: right;">
			<button class="cancel" on:click={ salir }>Cancel</button>
			<button class="ok" on:click={submit}>Ok</button>
		</div>
		{#if toastAlertMessage }
			<span class="toast v-center">{#if loading}<div class="spinner"></div>{/if}{ toastAlertMessage }</span>
		{/if}
		{#if toastDialogMessage }
				{#if emailOk}
					<span class="toast v-center">{ toastDialogMessage }
						<button class="rounded" on:click={ cancelToastDialog }>✖</button>
					</span>
				{:else}
					<span class="toast h-center">{ toastDialogMessage }<hr>
						<div>
							<button class="rounded tertiary" on:click={ registrar }>✔</button>
							<button class="rounded" on:click={ cancelToastDialog }>✖</button>
						</div>
					</span>
				{/if}
		{/if}

	</div>
</div>
